import React from 'react';

import { ClinicalCondition } from '../types';
import { formatConditionCode, formatDate, formatEnumLabel } from '../utils/formatters';
import * as Style from '../style.module.scss';
import EhrCard from './EhrCard';
import StatusPill from './StatusPill';
import { clinicalStatusTone } from './StatusPill/tones';

type Props = {
    conditions: ClinicalCondition[];
    lastSynced?: string;
};

const Conditions: React.FC<Props> = ({ conditions, lastSynced }) => (
    <EhrCard
        title="Conditions"
        meta={lastSynced}
        isEmpty={!conditions.length}
        emptyMessage="No conditions on file."
    >
        <div className={`${Style.list} ${Style.withCode}`}>
            {conditions.map((condition) => {
                const code = formatConditionCode(condition);

                return (
                    <div key={condition.id} className={Style.listRow}>
                        <div>
                            <span>{condition.name || 'Unnamed'}</span>
                            {condition.removed_at ? (
                                <span className={Style.removed}>
                                    {`Removed ${formatDate(condition.removed_at)}`}
                                </span>
                            ) : null}
                            {condition.notes ? (
                                <span className={Style.subText}>{condition.notes}</span>
                            ) : null}
                        </div>
                        <span className={Style.code} title={code}>
                            {condition.icd_code || code}
                        </span>
                        <StatusPill
                            label={formatEnumLabel(condition.status)}
                            tone={clinicalStatusTone(condition.status)}
                        />
                    </div>
                );
            })}
        </div>
    </EhrCard>
);

export default Conditions;
